import { render, staticRenderFns } from "./scene_1.vue?vue&type=template&id=d2f4cf66&"
import script from "./scene_1.vue?vue&type=script&lang=ts&"
export * from "./scene_1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports